import { render } from "./HomepageUserPractice.vue?vue&type=template&id=713fd343"
import script from "./HomepageUserPractice.vue?vue&type=script&lang=js"
export * from "./HomepageUserPractice.vue?vue&type=script&lang=js"

import "./HomepageUserPractice.vue?vue&type=style&index=0&id=713fd343&lang=scss"

import exportComponent from "/home/bshipaa/sites/app.bitesizehipaa.com/bss/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__